var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFriendRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 3.4375C11.6875 3.05781 11.3797 2.75 11 2.75C10.6203 2.75 10.3125 3.05781 10.3125 3.4375V5.72917C10.3125 6.10886 10.6203 6.41667 11 6.41667C11.3797 6.41667 11.6875 6.10886 11.6875 5.72917V3.4375Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65949 4.76476C6.41542 4.4739 5.98178 4.43596 5.69092 4.68003C5.40005 4.92409 5.36211 5.35774 5.60617 5.6486L7.07923 7.40411C7.32329 7.69498 7.75694 7.73292 8.0478 7.48886C8.33866 7.24479 8.3766 6.81115 8.13254 6.52028L6.65949 4.76476Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3825 5.64872C16.6266 5.35786 16.5887 4.92421 16.2978 4.68015C16.007 4.43608 15.5733 4.47402 15.3292 4.76489L13.8562 6.52041C13.6121 6.81127 13.65 7.24491 13.9409 7.48898C14.2318 7.73304 14.6654 7.6951 14.9095 7.40424L16.3825 5.64872Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78502 8.25C3.96863 8.25 3.23231 8.74088 2.91833 9.49447L2.55544 10.3654C2.39531 10.7497 2.01983 11 1.60352 11C1.22382 11 0.916016 11.3078 0.916016 11.6875V17.6458C0.916016 18.0255 1.22382 18.3333 1.60352 18.3333H6.77294C8.61399 18.3333 10.1526 16.9322 10.3244 15.0992L10.4727 13.5172C10.6685 11.429 9.02574 9.625 6.92843 9.625C6.83817 9.625 6.75388 9.5799 6.70381 9.50483L6.46762 9.15051C6.09257 8.58792 5.46116 8.25 4.78502 8.25Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1626 8.25C16.4864 8.25 15.855 8.58792 15.48 9.15051L15.2438 9.50483C15.1937 9.5799 15.1094 9.625 15.0192 9.625C12.9219 9.625 11.2791 11.429 11.4748 13.5172L11.6231 15.0992C11.795 16.9322 13.3336 18.3333 15.1747 18.3333H20.3441C20.7238 18.3333 21.0316 18.0255 21.0316 17.6458V11.6875C21.0316 11.3078 20.7238 11 20.3441 11C19.9278 11 19.5523 10.7497 19.3922 10.3654L19.0293 9.49447C18.7153 8.74088 17.9789 8.25 17.1626 8.25Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFriendRequest);
export default __webpack_public_path__ + "static/media/icon-friend-request.1c1dfdd012803382aaf6bd247df21d2e.svg";
export { ForwardRef as ReactComponent };